import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[pgsInputFilter]'
})
export class PgsInputFilterDirective {

  regexStr = '^[ña-zÑA-Z0-9@. _-]+$';

  // constructor() { }
  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
    this.validateFields(event);
  }

  validateFields(event) {
    setTimeout(() => {

      this.el.nativeElement.value = this.el.nativeElement.value.replace(/^[^ña-zÑA-Z0-9@. _-]/g, '');
      event.preventDefault();

    }, 100);
  }

}
